export enum StockManagementConfigurationGroupEnum {
  settings = 'Settings'
}
